{
  "common": {
    "actions": {
      "save": "Save",
      "edit": "Edit",
      "saveChanges": "Save changes",
      "saveAndExit": "Save and exit",
      "cancel": "Cancel",
      "back": "Back",
      "delete": "Delete",
      "reject": "Reject",
      "accept": "Accept",
      "add": "Add",
      "applyChanges": "Apply changes",
      "preview": "Preview",
      "close": "Close",
      "revert": "Revert",
      "clickHere": "Click here",
      "continue": "Continue",
      "export": "Export",
      "learnMore": "Learn more",
      "previous": "Previous",
      "next": "Next",
      "complete": "Complete",
      "change": "Change"
    },
    "statuses": {
      "canceled": "Canceled",
      "rejected": "Rejected",
      "accepted": "Accepted",
      "success": "Success",
      "failed": "Failed",
      "required": "Required",
      "open": "Open",
      "closed": "Closed",
      "imported": "Imported",
      "draft": "Draft",
      "forReview": "For review",
      "forApproval": "For approval",
      "approved": "Approved",
      "approvalDeclined": "Approval declined",
      "effective": "Effective",
      "superseded": "Superseded"
    },
    "labels": {
      "archivedRegistryItem": "{{name}} (Archived)",
      "deactivatedUser": "{{name}} (Deactivated)",
      "name": "Name",
      "type": "Type",
      "email": "Email",
      "password": "Password",
      "comments": "Comments",
      "properties": "Properties",
      "assignedTo": "Assigned to",
      "eventTitle": "Event title",
      "eventId": "Event ID",
      "none": "None",
      "reason": "Reason",
      "events": "Events",
      "created": "Created",
      "lastModified": "Last modified",
      "steps": "Steps",
      "fields": "Fields",
      "version": "Version",
      "owner": "Owner",
      "eventType": "Event type",
      "eventTypes": "Event types",
      "taskStatus": "Task status",
      "createdBetween": "Created between",
      "due": "Due",
      "status": "Status",
      "owners": "Owners",
      "startDate": "Start date",
      "endDate": "End date",
      "risk": "Risk",
      "severity": "Severity",
      "ownerEmail": "Owner email",
      "probability": "Probability",
      "product": "Product",
      "products": "Products",
      "rootCause": "Root cause",
      "rootCauses": "Root causes",
      "relatedRecords": "Relationships",
      "source": "Source",
      "assignee": "Assignee",
      "description": "Description",
      "visible": "Visible",
      "required": "Required",
      "title": "Title",
      "prefix": "Prefix",
      "attachments": "Attachments",
      "resolution": "Resolution",
      "relatedTo": "Related to",
      "approvers": "Approvers",
      "reviewers": "Reviewers",
      "total": "Total",
      "approvalDate": "Approval date",
      "id": "ID",
      "tags": "Tags",
      "emptyProducts": "Empty products",
      "emptyRootCauses": "Empty root causes",
      "emptyTags": "Empty tags",
      "emptySeverities": "Empty severities",
      "emptyProbabilities": "Empty probabilities",
      "suppliers": "Suppliers",
      "dueDate": "Due date",
      "currentDueDate": "Current due date",
      "newDueDate": "New due date",
      "selectANewOwner": "Select a new owner",
      "tasks": "Tasks",
      "usersList": "Users list",
      "createdBefore": "Created before",
      "createdAfter": "Created after",
      "dueAfter": "Due after",
      "dueBefore": "Due before",
      "resolvedAfter": "Resolved after",
      "resolvedBefore": "Resolved before",
      "overdue": "Overdue",
      "onTime": "On time",
      "integrationVariables": "Integration variables",
      "comment": "Comment",
      "currentOwner": "Current owner",
      "newOwner": "New owner",
      "defaultSections": "Default sections",
      "formSteps": "Form steps",
      "capturedIn": "Captured in",
      "inSection": "In section",
      "open": "Open",
      "canceled": "Canceled",
      "completed": "Completed",
      "templateOwner": "Template owner",
      "timeLimitDays": "Time limit (days)",
      "validationStepTimeDelayDays": "Validation step time delay (days)",
      "newTemplateOwner": "New template owner",
      "defaultContent": "Default content",
      "sectionWithPosition": "Section {{position}}",
      "back": "Back",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "yes": "Yes",
      "no": "No",
      "view": "View",
      "resolved": "Resolved",
      "closed": "Closed",
      "imported": "Imported",
      "manage": "Manage",
      "emptyState": "--",
      "order": "Order",
      "fullName": "Full name",
      "groups": "Groups",
      "taskName": "Task name",
      "approve": "Approve",
      "decline": "Decline",
      "revert": "Revert",
      "eventClosed": "Event Closed",
      "stepCompleted": "Step Completed",
      "stepReverted": "Step reverted",
      "eventReopened": "Event Reopened",
      "reviewersAssigned": "Reviewers assigned!",
      "approversAssigned": "Approvers assigned!",
      "and": "and",
      "content": "Content",
      "form": "Form",
      "validationWithType": "Validation ({{type}})",
      "reopen": "Reopen",
      "qualityApproverRequired": "Quality Approver Required"
    },
    "placeholders": {
      "email": "Email...",
      "password": "Password...",
      "enterANumber": "Enter a number",
      "writeAComment": "Write a comment...",
      "searchFor": "Search for {{domain}} to add...",
      "noResults": "No results",
      "startTypingToSearchFor": "Start typing to search for",
      "newestFirst": "Newest first",
      "oldestFirst": "Oldest first"
    },
    "errors": {
      "defaultErrorMessage": "There was a problem communicating with the server.",
      "timeZoneMissingMessage": "Could not find the user timezone",
      "invalidCredentials": "Invalid credentials",
      "somethingHasGoneWrong": "Something has gone wrong!",
      "currentCompanyRoleError": "Unable to resolve user's role in the current instance",
      "failedToFetchEventDetails": "Failed to fetch event details",
      "duplicateTitlesNotAllowed": "Duplicate titles are not allowed. Please use unique titles.",
      "invalidCharactersInTitle": "Invalid character(s) in title: {{characters}}",
      "missingRequiredFieldsClickHere": "There are some missing required fields on the event. Click here to view the required event fields.",
      "missingRequiredFieldsWithPrefix": "...event. Click here to view the required event fields.",
      "invalidCharactersInTitlePrefix": "Invalid character(s) in title:"
    },
    "notifications": {
      "fileReady": "File Ready",
      "preparingFileForDownload": "Preparing file for download",
      "error": "Error",
      "userReassigned": "User reassigned",
      "eventCreated": "Event created",
      "missingInformation": "Missing information",
      "success": "Success",
      "draftDeleted": "Draft deleted",
      "draftNotDeleted": "Draft not deleted",
      "ownerChanged": "Owner changed",
      "ownerNotChanged": "Owner not changed",
      "eventOpened": "Event opened",
      "eventNotOpened": "Event not opened",
      "eventUpdated": "Event updated",
      "eventNotUpdated": "Event not updated",
      "taskCompleted": "Task completed",
      "taskNotCompleted": "Task not completed",
      "failed": "Failed",
      "tagsUpdated": "Tags updated",
      "tagsNotUpdated": "Tags not updated",
      "eventPropertiesUpdated": "Event properties updated",
      "newEventCreated": "New event created",
      "eventNotCreated": "Event not created",
      "couldNotRetrieveEventMetadata": "Could not retrieve event metadata",
      "couldNotRetrieveGroups": "Could not retrieve groups",
      "failedToFetchEventTemplateDetails": "Failed to fetch event template details",
      "eventUpdateFailed": "Event update failed",
      "revertedToDraft": "Reverted to draft",
      "changesSaved": "Changes saved",
      "failedToUpdateTask": "Failed to update task",
      "couldNotRetrieveTags": "Could not retrieve tags",
      "couldNotRetrieveUsers": "Could not retrieve users",
      "reviewed": "Reviewed",
      "stepNotReviewed": "Step not reviewed",
      "eventReassignmentFailed": "Event reassignment failed",
      "couldNotRetrieveEventTypes": "Could not retrieve event types",
      "failedToFetchFormTemplateDetails": "Failed to fetch form template details",
      "formTemplateUpdateFailed": "Form template update failed",
      "eventTemplateUpdated": "Event template updated",
      "eventTemplateNotUpdated": "Event template not updated",
      "newDraftCreated": "New draft created",
      "creatingNewDraftFailed": "Creating new draft failed",
      "templateArchived": "Template archived",
      "templateArchivingFailed": "Template archiving failed",
      "templateRestored": "Template restored",
      "templateRestoringFailed": "Template restoring failed",
      "missingRequiredFields": "Missing required fields",
      "temporarilyUnableToRetrieveAllEventProperties": "Temporarily unable to retrieve all event properties",
      "reviewRequest": "Review request",
      "yourReviewIsRequired": "Your review is required",
      "fileReadyToDownloadPrefix": "The file is now available to",
      "fileReadyToDownloadLinkText": "download",
      "couldNotRetrieveSummaryFromAI": "Could not retrieve summary from AI service",
      "propertiesUpdateForEvent": "Properties update for event {{eventCode}} successfully updated",
      "eventCreatedDesc": "\"{{eventCode}} | {{eventTitle}}\" was created",
      "eventCreatedWithTitle": "\"{{title}}\" was created",
      "tagsUpdatedDesc": "Tags for {{eventCode}} successfully updated",
      "eventUpdatedToLatestTemplate": "Event has been updated to the latest event template.",
      "eventNotUpdatedToLatestTemplate": "Event has not been updated to the latest event template.",
      "draftSuccessfullyDeleted": "The draft was successfully deleted",
      "failedToDeleteTheDraft": "Failed to delete the draft",
      "pleaseSaveTheEventTemplateFirst": "Please save the event template first",
      "wellLetYouKnowWhenFileIsReady": "We'll let you know when the file is ready",
      "exportingEventCodeTitle": "Exporting {{code}} {{title}}",
      "ownerSuccessfullyChanged": "Owner for {{eventCode}} successfully changed",
      "theTeamHasBeenNotified": "The team has been notified. Please refresh or try again later."
    },
    "filters": {
      "filterByOwner": "Filter by owner...",
      "filterByCollaborator": "Filter by collaborator...",
      "filterByAssignee": "Filter by assignee...",
      "filterByCreatedDate": "Filter by created date...",
      "filterByDueDate": "Filter by due date...",
      "filterByResolvedDate": "Filter by resolved date...",
      "filterByDueStatus": "Filter by due status...",
      "filterByProduct": "Filter by product...",
      "filterByRootCause": "Filter by root cause...",
      "filterByTags": "Filter by tags...",
      "filterByProbability": "Filter by probability...",
      "filterByNameEmailOrGroupName": "Filter by name, email or group name...",
      "filterBySeverity": "Filter by severity...",
      "searchRelatedRecords": "Filter by relationships...",
      "searchMore": "Search more...",
      "filterByStatus": "Filter by status...",
      "filterByEventType": "Filter by event type...",
      "approversAdded": "Approvers added",
      "approversRemoved": "Approvers removed",
      "reviewersAdded": "Reviewers added",
      "reviewersRemoved": "Reviewers removed",
      "reasonForRemovingTheUserType": "Reason for removing the {{userType}}..."
    },
    "tables": {
      "noMatchingEventsFound": "No matching events found",
      "noMatchingTasksFound": "No matching tasks found"
    },
    "pagination": {
      "show": "Show",
      "showSpace": "Show ",
      "previousPage": "previous page",
      "nextPage": "next page"
    },
    "exports": {
      "fileReady": "File Ready",
      "preparingFileForDownload": "Preparing file for download",
      "failedToExportTheFile": "Failed to export the file.",
      "xlsx": "XLSX",
      "pdf": "PDF"
    },
    "units": {
      "days": "days"
    },
    "debug": {
      "noFlagsReturnedInThisEnvironment": "No flags returned in this environment",
      "knownFlags": "Known Flags",
      "rawLDFlagValues": "Raw LD Flag Values"
    }
  },
  "templates": {
    "labels": {
      "eventTemplates": "Event templates",
      "templateStatus": "Template status",
      "templateOwner": "Template owner",
      "defaultAssignee": "Default assignee",
      "defaultEventOwner": "Default event owner",
      "defaultTimeLimit": "Default time limit",
      "validationStepTimeDelay": "Validation step time delay",
      "timeLimitDays": "Time limit (days)",
      "validationStepTimeDelayDays": "Validation step time delay (days)",
      "defaultSections": "Default sections",
      "formSteps": "Form steps",
      "inSection": "In section"
    },
    "steps": {
      "dueDays": {
        "header": "Due days",
        "tooltip": "The number of days after an event is created from this template before this step becomes due. The countdown starts at event creation time.",
        "validation": {
          "range": "Enter a whole number of days between 0 and 100000."
        }
      }
    },
    "actions": {
      "editEventTemplate": "Edit event template",
      "createTemplateDraft": "Create template draft",
      "makeEffective": "Make effective",
      "addStep": "Add step",
      "deleteDraft": "Delete draft",
      "changeTemplateOwner": "Change template owner",
      "createEventTemplate": "Create event template",
      "renameStep": "Rename step",
      "changeValidationStepType": "Change validation step type",
      "selectResolution": "Select resolution",
      "updateTemplate": "Update template",
      "deleteStep": "Delete step",
      "createTemplate": "Create template",
      "addSection": "Add section",
      "editContentTemplate": "Edit content template"
    },
    "statuses": {
      "draft": "Draft",
      "effective": "Effective",
      "archived": "Archived",
      "forApproval": "For approval",
      "approvalDeclined": "Approval declined",
      "superseded": "Superseded",
      "allActiveStatuses": "All open statuses"
    },
    "messages": {
      "eventTemplateCreated": "Event template created",
      "templateCreatedWithTitle": "\"{{title}}\" was created",
      "eventTemplateCreatedFailTitle": "Event template not created",
      "makeEffectiveSuccessMessage": "Event template was made effective",
      "eventTemplateUpdateFailTitle": "Event template not updated",
      "changeEventTemplateOwnerSuccessMessage": "Updated template owner",
      "duplicatedStepNames": "Duplicated step names!",
      "updatesHaveBeenMadeToThisTemplate": "Updates have been made to this template",
      "pleaseChooseAResolution": "Please choose a resolution for the following template changes. No changes will be applied to the document at this time.",
      "aPrefixWillBeAutomaticallyAdded": "A prefix will be automatically added to every event created.",
      "eachEventMustBeResolved": "Each event must be resolved in given number of days. This is a default value and may be changed during event creation.",
      "determinesHowManyDays": "Determines how many days must pass before being able to complete approval of final step.",
      "templateSuccessfullyUpdated": "Template successfully updated",
      "failedToUpdateTheTemplate": "Failed to update the template:",
      "makeThisAResolutionSection": "Make this a resolution section",
      "contentTemplateNotCreated": "Content template not created",
      "formTemplateNotCreated": "Form template not created",
      "editContentTemplate": "Edit content template",
      "editFormTemplate": "Edit form template",
      "startBuildingYourForm": "Start building your form",
      "makeThisTheValidationStep": "Make this the validation step",
      "onlyOneResolutionSectionAllowed": "Only one section of type \"Resolution\" is allowed. Please change type of other section first.",
      "resolutionSectionDescription": "Section of type \"Resolution\" will be presented as an editable checkbox to confirm if issue was resolved ok or not.",
      "optionalQualityApproverHelper": "For steps where Quality Approver is optional, at least one Other Approver is required."
    },
    "modals": {
      "makeEffectiveModalHeadingText": "Make template effective",
      "makeEffectiveModalSubText": "Enter your digital signature to make this template effective.",
      "deleteDraftConfirmationHeader": "Delete draft?",
      "deleteDraftConformationBody": "Are you sure you want to delete this draft? Your changes will not be saved.",
      "exportModalTitle": "Export event template",
      "exportModalSubText": "Qualio exports event templates as a PDF.",
      "exportCoverPageTitle": "Cover page",
      "exportCoverPageSubText": "A cover page includes event template properties as the first page of the template export.",
      "exportIncludeCoverPage": "Include cover page"
    },
    "fields": {
      "currentEventTemplateOwnerLabel": "Current",
      "reasonForChangeInputLabel": "Reason for change",
      "reasonForChangePlaceholder": "Add a reason for making this template effective..."
    },
    "helpText": {
      "templateFieldControlDescription": "Show fields that you want users to collect for this type of event, or hide them if they're not relevant. You can also select if a field is required or not. Required fields will be checked for completion upon closing the event.",
      "templateFieldControlDescriptionForEventCapture": "Show fields that you want users to collect for this type of event, or hide them if they're not relevant. You can specify a form step to capture the field (defaults to event properties). You can also select if a field is required or not. Required fields will be checked for completion upon closing the event.",
      "defaultAssigneeHelper": "An owner will be assigned automatically upon event creation and can be changed at any time. A default assignee must be assigned in order to create events automatically via an integration.",
      "defaultEventOwnerHelper": "An owner will be assigned automatically upon event creation and can be changed at any time. A default event owner must be assigned in order to create events automatically via an integration.",
      "prefixHelpText": "A prefix will be automatically added to every event created using this template. The prefix can contain letters and digits only.",
      "defaultTimeLimitDefaultHelpText": "Each event must be resolved in given number of days. This is a default value, and may be changed during event creation.",
      "defaultTimeLimitEventDueDateHelpText": "Each event must be resolved in a given number of days. Initial event due dates will be calculated based on this value.",
      "validationStepTimeDelayHelpText": "Determines how many days must pass before being able to complete approval of the final step."
    },
    "validation": {
      "emptyTitlesAreNotAllowed": "Empty titles are not allowed",
      "duplicateTitlesAreNotAllowed": "Duplicate titles are not allowed"
    },
    "ckeditor": {
      "insertCodeBlock": "Insert code block",
      "insertCodeBlockCaps": "Insert Code Block",
      "paragraph": "Paragraph",
      "heading1": "Heading 1",
      "heading2": "Heading 2",
      "heading3": "Heading 3",
      "heading4": "Heading 4",
      "normal": "Normal"
    },
    "content": {
      "resolveSection": "Section '{{sectionTitle}}' is marked to be removed, please select a resolution"
    }
  },
  "forms": {
    "labels": {
      "fieldTitle": "Field title",
      "helpText": "Help text",
      "sectionFieldTitle": "Section title",
      "sectionDescription": "Section description",
      "defaultContent": "Default content",
      "multiSelect": "Multi-select",
      "optionSectionLabel": "Options",
      "reviewStep": "Review step"
    },
    "actions": {
      "completeForm": "Complete form",
      "addField": "Add field",
      "addFormElement": "Add form element",
      "createNewField": "Create new field",
      "chooseQualioResource": "Choose Qualio resource",
      "addHelpText": "Add help text",
      "editHelpText": "Edit help text",
      "addSectionDescription": "Add section description",
      "editSectionDescription": "Edit section description",
      "addDefaultContent": "Add default content",
      "editDefaultContent": "Edit default content",
      "addOption": "Add an option",
      "startBuildingForm": "Start building your form",
      "editForm": "Edit form",
      "sendForReview": "Send for review",
      "sendForApproval": "Send for approval",
      "reassignStep": "Reassign step",
      "manageReviewers": "Manage reviewers",
      "manageApprovers": "Manage approvers",
      "revertToDraft": "Revert to draft",
      "markAsReviewed": "Mark as reviewed",
      "reassignStepAction": "Reassign step"
    },
    "messages": {
      "noFormElementAddedYet": "No form element added yet",
      "addFormElementToStartBuilding": "Add a form element to start building your form",
      "formUpdateSuccessTitle": "Form values updated",
      "formUpdateSuccessMessage": "Form successfully updated",
      "formUpdateFailedTitle": "Form not updated",
      "formMissingMessage": "Could not find the form",
      "formPreviewWarning": "You are previewing a form",
      "formPreviewDuplicateLabelWarning": "One or more fields have duplicate labels. Edit the form to make adjustments as you see fit.",
      "noFormYet": "No form to preview yet",
      "startFormCopy": "Let's start building your form. With forms, you can collect specific event information and later analyze and report on your findings.",
      "approversUpdateSuccessTitle": "{{approverType}} updated",
      "approversUpdateSuccessMessage": "{{approverType}} for this form successfully updated",
      "approversUpdateFailedTitle": "{{approverType}} update failed",
      "approversUpdateFailedMessage": "One or more {{approverType}} is not updated, please review your {{approverType}}",
      "atLeastOneAssigneeRequiredMessage": "Form in \"{{status}}\" status requires at least one assignee",
      "removingActionedApproverErrorMessage": "Already actioned {{approverType}} cannot be removed",
      "reviewForm": "Review \"{{formName}}\"",
      "disabledDeleteTooltip": "{{fieldType}} field visibility is set in the template. Turn visibility off to automatically remove this field from the step.",
      "disableRequiredTooltip": "{{fieldType}} field mandatory settings is available in the template. Toggle the \"Required\" switch in the template fields to manage it.",
      "pleaseMarkThisStepAsReviewed": "Please mark this step as reviewed",
      "reviewersAdded": "Reviewers added"
    },
    "fieldTypes": {
      "text": "Single line text",
      "richText": "Rich text paragraph",
      "date": "Date",
      "dropdown": "Dropdown",
      "boolean": "Yes / No",
      "numeric": "Numeric",
      "attachment": "Attachment",
      "document": "Document",
      "event": "Event",
      "supplier": "Supplier",
      "user": "User",
      "section": "Section",
      "checkbox": "Checkboxes",
      "radio": "Radio buttons",
      "changeRequest": "Change request",
      "registry": "Registry",
      "designControls": "Design controls",
      "training": "Training",
      "documentTemplates": "Templates",
      "eventTemplates": "Event templates",
      "task": "Task"
    },
    "validation": {
      "optionValueRequired": "Option value required",
      "optionValueTooLarge": "Option value must be less than 512 characters long",
      "optionValueUnique": "Options cannot have duplicate names",
      "requiredFieldHelper": "This field is required for closed events",
      "formContentInvalidError": "Form content is not valid",
      "required": "Required"
    },
    "statusChanges": {
      "sentForReview": "Sent for review",
      "sentForApproval": "Sent for approval",
      "revertedToDraft": "Reverted to draft",
      "cannotSendForReview": "Cannot send for review",
      "cannotSendForApproval": "Cannot send for approval",
      "cannotRevertToDraft": "Cannot revert to draft",
      "cannotUpdateTheForm": "Cannot update the form",
      "wasSentForReview": "{{formTitle}} was sent for review",
      "wasSentForApproval": "{{formTitle}} was sent for approval",
      "wasRevertedToDraft": "was reverted to draft"
    },
    "approvers": {
      "reviewers": "Reviewers",
      "qualityApprovers": "Quality approvers",
      "otherApprovers": "Other approvers",
      "approverDeclinedStepOnDate": "{{approverName}} declined this step on {{date}} with the following comment:"
    },
    "errors": {
      "cannotSendForApprovalMissingRequiredFields": "Cannot send for approval as there are missing required fields in event",
      "pleaseAddApproversBeforeSubmitting": "Please add approvers before submitting for approval. Also, there are some missing required fields on the event.",
      "missingRequiredFieldsOnEvent": "There are some missing required fields on the event.",
      "toViewTheRequiredEventFields": "to view the required event fields."
    }
  },
  "events": {
    "labels": {
      "eventProperties": "Event properties",
      "relatedEvents": "Related events",
      "relatedDocuments": "Related documents",
      "sourceEvent": "Source event",
      "escalatedTo": "Escalated to",
      "relatedSuppliers": "Related suppliers",
      "events": "Events",
      "tasks": "Tasks",
      "products": "Products",
      "collaborators": "Collaborators"
    },
    "actions": {
      "createEvent": "Create event",
      "editEvent": "Edit event",
      "openEvent": "Open event",
      "cancelEvent": "Cancel event",
      "closeEarly": "Close early",
      "updateEvent": "Update event",
      "updateTags": "Update tags",
      "escalateAndCreateNewEvent": "Escalate and create new event",
      "exportEvent": "Export event",
      "changeOwner": "Change owner",
      "changeDueDate": "Change due date",
      "updateEventProperties": "Update event properties",
      "exportListAsXLSX": "Export list as XLSX",
      "exportListAsPDF": "Export list as PDF",
      "approveStep": "Approve step",
      "declineStep": "Decline step",
      "reopenEvent": "Reopen event",
      "closeEvent": "Close event"
    },
    "statuses": {
      "open": "Open",
      "closed": "Closed",
      "imported": "Imported",
      "rejected": "Rejected",
      "canceled": "Canceled"
    },
    "messages": {
      "eventMissingMessage": "Could not find the event",
      "eventAcceptedMessage": "You accepted this event",
      "eventRejectedMessage": "You rejected this event",
      "eventCanceledMessage": "You canceled this event",
      "defaultOwnerNoPermissionTitle": "Default owner has no permission",
      "defaultOwnerNoPermissionMessage": "The default owner does not have required",
      "defaultAssigneeNoPermissionTitle": "Default assignee has no permission",
      "defaultAssigneeNoPermissionMessage": "The default assignee does not have required permission",
      "eventPropertiesNotUpdatedError": "Event properties not updated",
      "missingRequiredFields": "Missing required fields",
      "temporarilyUnableToRetrieveAllEventProperties": "Temporarily unable to retrieve all event properties",
      "theTeamHasBeenNotifiedPleaseRefreshOrTryAgainLater": "The team has been notified. Please refresh or try again later.",
      "theFollowingEventFieldsWillBeCopiedToTheNewEvent": "The following event fields will be copied to the new event:",
      "youCanEditEventFieldsAfterCreation": "You can edit event fields after creation.",
      "provideAnyInformationYouHave": "Provide any information you have",
      "theFollowingEventFieldsWillBeCopied": "The following event fields will be copied to the new event:",
      "removedFromProperties": "Removed from properties:",
      "addedToProperties": "Added to properties:",
      "requiredColon": "Required:",
      "notRequired": "Not required:",
      "thisActionAffectsStepApprovalStatus": "This action affects step approval status",
      "manageApproverType": "Manage {{approverType}}",
      "approvalDeclined": "Approval declined",
      "manageReviewers": "Manage reviewers",
      "manageQualityApprovers": "Manage quality approvers",
      "manageOtherApprovers": "Manage other approvers",
      "manageApprovers": "Manage approvers",
      "selectUsersForReviewerFeedback": "Select users to provide feedback and suggestions on the event form.",
      "selectUsersForQualityApproval": "Select users who are required for final event form approval and sign-off.",
      "selectUsersForOtherApproval": "Select users responsible for final event form approval and sign-off.",
      "selectUsersForApproval": "Select users responsible for final event form approval and sign-off.",
      "selectProductForEvent": "Select the product associated with this event.",
      "selectRootCauseForEvent": "Select the root cause of this event.",
      "riskCalculationDescription": "Risk is calculated based on the probability and severity fields of an event. ",
      "linkSuppliersToEvent": "Link suppliers that are related to this event. ",
      "canceledOn": "Canceled on",
      "rejectedOn": "Rejected on",
      "closedEarlyOn": "Closed early on",
      "cancelationReason": "Cancelation reason",
      "rejectionReason": "Rejection reason",
      "closeReason": "Close reason",
      "missingQualityTypeApprover": "Missing quality type approver",
      "requiredFieldsMustBeCompletedBeforeApprovalAndClosure": "The following fields must be completed before this event can be approved and closed:",
      "editEventToFillMissingRequiredFields": "Update the event to fill in the missing required fields.",
      "removingApproversWarning": "Removing these approvers will change the step from for approval to approved.",
      "manageCollaborators": "Manage collaborators",
      "selectUsersForCollaboration": "Select users who can complete or assign event steps, as well as create and manage tasks.",
      "collaboratorsAdded": "Collaborators added",
      "collaboratorsRemoved": "Collaborators removed"
    },
    "modals": {
      "eventAcceptSubText": "Enter your digital signature to accept the event",
      "eventCancelSubText": "This action will cancel all event steps and mark the event as canceled.",
      "eventRejectSubText": "Enter your digital signature to reject the event",
      "approveStepSubText": "Enter your digital signature to approve the step",
      "declineStepSubText": "Enter your digital signature to decline the step",
      "closeEarlySubText": "This action will cancel all event steps and mark the event as closed.",
      "reopenEventSubText": "Are you sure that you want to reopen this issue?",
      "eventSuccessfullyClosed": "Event {{eventCode}} Successfully closed",
      "eventSuccessfullyReopened": "Event {{eventCode}} Successfully reopened",
      "changeDueDateReasonPlaceholder": "Add a reason for changing the due date...",
      "dueDateSuccessfullyUpdated": "Due date successfully updated",
      "collaboratorsSuccessfullyUpdated": "Collaborators successfully updated"
    },
    "create": {
      "provideRequiredInformationToCreateAnEvent": "Provide required information to create an event. You can add details later."
    },
    "tabs": {
      "details": "Details"
    }
  },
  "tasks": {
    "labels": {
      "taskStatus": "Task status",
      "assignTo": "Assign to",
      "reassignTo": "Reassign to"
    },
    "actions": {
      "createTask": "Create task",
      "completeTask": "Complete task",
      "reopenTask": "Reopen task",
      "completeStep": "Complete step",
      "actionStep": "Action Step",
      "revertStep": "Revert step",
      "revertStepCompletion": "Revert step completion?",
      "assignStep": "Assign step",
      "reassign": "Reassign",
      "assign": "Assign",
      "comment": "Comment"
    },
    "modals": {
      "signOffToRevertCompletion": "Sign off to revert the completion of the \"{{stepLabel}}\" step",
      "stepCompletionWasReverted": "\"{{stepLabel}}\" step completion was reverted",
      "signOffToCompleteStep": "Sign off to complete the \"{{stepLabel}}\" step",
      "stepWasMarkedComplete": "\"{{stepLabel}}\" step was marked as complete"
    },
    "messages": {
      "userReassigned": "User reassigned",
      "userReassignedSuccessfully": "User reassigned successfully.",
      "completeFormAndSendForReview": "Complete form and send it for review and approval when ready.",
      "noFormAssociatedWithStep": "There is no form associated with this step.",
      "thisFieldRequiredBeforeClosing": "This field is required before closing the event.",
      "cannotSendForApprovalUntil": "This resolution cannot be sent for approval until",
      "createAndAssignTasks": "Create and assign tasks and track their progress.",
      "noTasksAssociatedWithStep": "There are no tasks associated with this step."
    }
  },
  "products": {
    "confirmations": {
      "deleteProductConfirmation": "Are you sure you want to delete \"{{productName}}\"?"
    }
  },
  "rootCauses": {
    "labels": {
      "rootCauses": "Root causes"
    },
    "confirmations": {
      "deleteRootCauseConfirmation": "Are you sure you want to delete \"{{rootCauseName}}\" root cause?"
    }
  },
  "search": {
    "errors": {
      "searchFailed": "Could not fetch search results"
    }
  }
}
